<!-- A component to display a large heading -->
<template>
	<div
		v-html="richTextHtml"
		class="text-primary-700 font-serif text-5xl leading-snug font-bold md:text-5xl md:leading-snug lg:text-7xl lg:leading-tight"
	></div>
</template>

<script setup lang="ts">
defineProps({
	richTextHtml: {
		type: String,
		required: true,
	},
})
</script>
